































    import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
    import { LocaleMixin } from '@/locales/locale-mixin';
    import { BasicValidationMixin } from '@/validation/basic-validation-mixin';
    import { getModule } from 'vuex-module-decorators';
    import { CrmTypesStore } from '@/crm-types/store/crm-types-store';
    import { CrmTypeList, CrmTypeOption } from '@/crm-types/models/crm-type';

    const crmTypesStore = getModule(CrmTypesStore);

@Component({
    components: {}
})
    export default class PositionBasedAssignSelect extends Mixins(
        LocaleMixin,
        BasicValidationMixin
    ) {
    @Prop({ type: Boolean, default: false }) readonly ariaRequired!: boolean;
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean;
    @Prop({ default: false }) readonly hideDetails!: boolean | string;
    @Prop({ default: false }) isDisabled!: boolean;
    @Prop({ type: Boolean, default: true }) readonly isEmphasized!: boolean;
    @Prop({ type: String, default: 'Assign To *' }) readonly label!: string;
    @Prop({ type: Number, default: null }) readonly value!: number | null;

    private selected: number | null = null;
    private positionOptions: Array<CrmTypeOption> = [];

    @Watch('value')
    valueChanged() {
        this.selected = this.value;
    }

    async created() {
        await crmTypesStore.initList(CrmTypeList.STAFF_POSITIONS);
        this.positionOptions = crmTypesStore.listOptions(
            CrmTypeList.STAFF_POSITIONS
        );
        this.selected = this.value;
    }

    private handleInput(value: number | null) {
        this.selected = value;
        this.$emit('input', value);
    }
    }
